/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateRecordsSectionRequest
 */
export interface GenerateRecordsSectionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GenerateRecordsSectionRequest
     */
    guids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GenerateRecordsSectionRequest
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateRecordsSectionRequest
     */
    teamId?: string | null;
}

/**
 * Check if a given object implements the GenerateRecordsSectionRequest interface.
 */
export function instanceOfGenerateRecordsSectionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "guids" in value;
    isInstance = isInstance && "companyId" in value;

    return isInstance;
}

export function GenerateRecordsSectionRequestFromJSON(json: any): GenerateRecordsSectionRequest {
    return GenerateRecordsSectionRequestFromJSONTyped(json, false);
}

export function GenerateRecordsSectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateRecordsSectionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'guids': json['guids'],
        'companyId': json['company_id'],
        'teamId': !exists(json, 'team_id') ? undefined : json['team_id'],
    };
}

export function GenerateRecordsSectionRequestToJSON(value?: GenerateRecordsSectionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'guids': value.guids,
        'company_id': value.companyId,
        'team_id': value.teamId,
    };
}

